import PropTypes from 'prop-types';
import SafeImg from '@/components/shared/SafeImg';
import IdolName from '@/components/ui/IdolName';
import SuspendedMark from '@/components/ui/SuspendedMark';
import placeholder_portrait_55x55 from '@/assets/imgs/placeholders/portrait_55x55.png';

/**
 * 選擇偶像列表：頭像 + 暱稱 + 官方標記，每個偶像固定寬度（.idol-pick-item）
 * 用於登入時的 Choose your Idol 與偶像停權鎖定 modal。
 *
 * 停權偶像（idol_is_suspended）顯示灰階與 ban 標記，不可點選。
 *
 * @param {Array} idols - /idol/get-idol-array 回傳的偶像陣列
 * @param {Function} onPick - 點選未停權偶像時的回調 (idol) => void
 */
function IdolPickList({ idols, onPick }) {
  return (
    <div className="idol-pick-list d-grid gap-3 justify-content-center">
      {idols.map((idol) => {
        const isSuspended = idol.idol_is_suspended;
        return (
          <div
            key={idol.idol_id}
            className={`idol-pick-item d-flex align-items-center flex-column ${isSuspended ? '' : 'pointer idol-item'}`}
            onClick={isSuspended ? undefined : () => onPick(idol)}
          >
            <div className="position-relative mb-2 flex-shrink-0">
              <div className={`img-md ${isSuspended ? 'idol-suspended' : ''}`}>
                <SafeImg
                  className="img-fluid rounded-pill"
                  src={idol.idol_avatar_url || placeholder_portrait_55x55}
                />
              </div>
              {isSuspended && <SuspendedMark variant="icon" />}
            </div>
            <IdolName
              name={idol.idol_nick_name}
              isOfficial={idol.idol_is_official}
              className={`justify-content-center mw-100 mb-2 ${isSuspended ? 'idol-suspended' : ''}`}
            />
          </div>
        );
      })}
    </div>
  );
}

IdolPickList.propTypes = {
  idols: PropTypes.arrayOf(
    PropTypes.shape({
      idol_id: PropTypes.number.isRequired,
      idol_nick_name: PropTypes.string,
      idol_avatar_url: PropTypes.string,
      idol_is_official: PropTypes.bool.isRequired,
      idol_is_suspended: PropTypes.bool,
    })
  ).isRequired,
  onPick: PropTypes.func.isRequired,
};

export default IdolPickList;
